module.exports = __webpack_public_path__ + "img/case-studies3.0be846ca.jpg";